import ExcelJS from "exceljs";

export const exceljs = () => new ExcelJS.Workbook();
